<script>
    export let available_options;
    export let all_options;
    export let current_year;
    export let selected;
    export let height;
    export let width;

    const selectionClick = (option) => {
        selected = option;
    };
</script>

<div class="horizontal-button-selection">
    {#each all_options as option}
        <div class={`horizontal-button-selection__option`
                    + `${available_options.includes(option) ? ' available' : ''}`
                    + `${option === selected ? ' selected' : ''}`}
            style={`height:${height}px;width:${width}px;`}
            on:click={() => {if (available_options.includes(option)) selectionClick(option);}}
        >
            {option}
            {#if option === selected}
                <div 
                    id="horizontal-button-selection__current-year" 
                    style={`top:${parseInt(height) + 4}px;`}
                >
                    {current_year}
                </div>
            {/if}
        </div>
    {/each}
</div>

<style>
    .horizontal-button-selection {
        display: flex;
        flex-direction: row;
        vertical-align: middle;
    }
    .horizontal-button-selection__option {
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.2;
        border: 1px solid #CCC;

        position: relative;
    }
    .horizontal-button-selection__option.available {
        opacity: 1;
    }
    .horizontal-button-selection__option.selected {
        background-color: #1AAAD0;
        border: 1px solid #1AAAD0;
        cursor: default;
    }
    .horizontal-button-selection__option.available:not(.selected) {
        cursor: pointer;
    }
    #horizontal-button-selection__current-year {
        position: absolute;
        color: #1AAAD0;
        font-size: 11px;
        font-weight: 700;
        white-space: nowrap;
    }
</style>